import {
  SESSION_SET_AUTHENTICATION,
  SESSION_RESET_AUTHENTICATION,
  SESSION_SET_LOADING,
} from './actions';

const INITIAL_STATE = {
  loading: false,
  authenticatedData: null,
  menu: true,
  isAuthenticated: false,
};

export const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SESSION_SET_LOADING:
      return {
        ...state,
        loading: payload.loading,
      };
    case SESSION_SET_AUTHENTICATION:
      return {
        ...state,
        authenticated: payload.session?.success,
        authenticatedData: payload.session,
        loading: false,
      };
    case SESSION_RESET_AUTHENTICATION:
      return {
        ...state,
        authenticatedData: null,
        authenticated: false,
        loading: false,
        logoutReason: payload.logoutReason,
      };
    default:
      return state;
  }
};
